import React from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { WarningFilled } from '@mint-lib/icons';
import { Illustration } from '@mint-lib/illustrations';
import { Button, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { useRouter } from '@mint/routing';

const InternalServerErrorPageMobile = () => {
  const { t } = useTranslation('@mint-lib/error-boundary');

  const router = useRouter();

  return (
    <div className="mx-auto my-0 flex h-[calc(100vh-80px)] w-full flex-col">
      <div className="flex h-full max-w-76.5 flex-col items-center justify-center self-center">
        <Illustration className="size-40" component="IllustrationError500" />
        <div className="inline-flex flex-col justify-center gap-6">
          <div className="inline-flex items-center justify-center gap-2">
            <WarningFilled className="size-5 fill-error-main" />
            <p
              className={typographyVariants({
                variant: 'h3',
                color: 'error',
              })}
            >
              {t('500 Internal Server Error')}
            </p>
          </div>

          <p
            className={cn(
              'text-center',
              typographyVariants({
                variant: 'h1',
                color: 'primary',
              }),
            )}
          >
            {t('Something went wrong')}
          </p>

          <div
            className={cn(
              'text-left wrap-break-word',
              typographyVariants({
                variant: 'bodyLong01',
                color: 'primary',
              }),
            )}
          >
            <p>
              {t(
                'We are informed of your issue, we are working on it to resolve it.',
              )}
            </p>
          </div>
          <div className="flex flex-row gap-4">
            <Button
              onClick={() => {
                // Invalidate the route to reload the loader, and reset any router error boundaries
                router.invalidate();
              }}
              variant="outlined"
              size="large"
              color="primary"
            >
              {t('Reload the page')}
            </Button>

            <a href="https://support.mint.ai">
              <Button
                variant="contained"
                size="large"
                color="primary"
                aria-label={t('Preview file')}
              >
                {t('Visit our Help Center')}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export { InternalServerErrorPageMobile };
